import React from "react";
import PropTypes from "prop-types";

import Apiservice from "services/api";
import { Badge, Button, notification, List, Space, Card } from "antd";
import FullScreenModal from "components/utils/fullScreenModal";

const propTypes = {
  consultantId: PropTypes.number,
};

class PremiumPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { visible: false, premiums: [] };
  }

  close = () => this.setState({ visible: false });

  open = () => this.setState({ visible: true });

  componentDidMount() {
    Apiservice.getPremiumPurchasesByConsultant(this.props.consultantId)
      .then(({ data }) => {
        const premiums = data.map((i) => ({
          value: i.id,
          label: i.title,
        }));
        this.setState({ premiums });
      })
      .catch((error) => {
        notification.error({
          message: "Premium purchases can't be loaded",
        });
      });
  }

  render() {
    const { value, onChange } = this.props.input;
    return (
      <>
        <FullScreenModal
          open={this.state.visible}
          onCancel={this.close}
          title="Premium purchases"
        >
          <Space direction="vertical">
            <Card
              title={"Selected premium"}
              extra={
                <Button type="primary" danger onClick={() => onChange(null)}>
                  Clear
                </Button>
              }
            >
              {value
                ? this.state.premiums.find((i) => i.value === value)?.label
                : "Not selected premium"}
            </Card>
            <List
              dataSource={this.state.premiums}
              renderItem={(item) => (
                <List.Item
                  key={item.id}
                  style={{
                    background:
                      item.value === value
                        ? "var(--adm-color-primary)"
                        : "none",
                  }}
                  onClick={() =>
                    onChange(item.value === value ? null : item.value)
                  }
                >
                  {item.label}
                </List.Item>
              )}
            />
          </Space>
        </FullScreenModal>
        <Badge count={value ? 1 : 0}>
          <Button type="primary" ghost onClick={this.open}>
            Premiums
          </Button>
        </Badge>
      </>
    );
  }
}

PremiumPicker.propTypes = propTypes;

export default PremiumPicker;
